import { render } from "./Growth.vue?vue&type=template&id=0deb74f0"
import script from "./Growth.vue?vue&type=script&lang=js"
export * from "./Growth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\forteapp-sales\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QBtn,QDialog,QCard,QCardSection,QSelect});qInstall(script, 'directives', {ClosePopup});
